import React, { Component } from "react";

// CSS
import "../../../css/searchbar.css";

class SearchbarInput extends Component {
	render() {
		return (
			<div className="padded-listing">
				<div className="input-wrapper">
					<input
						type="text"
						name="search"
						placeholder={this.props.placeholder ? this.props.placeholder : "Search"}
						value={this.props.q}
						onKeyPress={e => this.props.handleKeyPress(e)}
						onChange={e => this.props.handleInputChange(e)}
						onKeyDown={e =>
							!!this.props.handleKeyDown ? this.props.handleKeyDown(e) : null
						}
						disabled={this.props.disabled}
						autoFocus
					/>
					<button
						className="search-btn icon-search"
						disabled={this.props.disabled}
						onClick={() => this.props.search()}
					/>
					{!!this.props.inProcess && <span className="icon-loading" />}
				</div>
			</div>
		);
	}
}

export default SearchbarInput;



// WEBPACK FOOTER //
// ./src/components/utils/searchbar/SearchbarInput.js